import * as React from 'react';

interface IProps {
  className?: string;
}

export const RealEstate: React.FC<IProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
      className={className}
    >
      <path
        fill="#0468FF"
        fillOpacity="0.1"
        fillRule="evenodd"
        d="M32 7.5L0 24v56h64V24l-8-4.125V8h-8v7.75L32 7.5z"
        clipRule="evenodd"
      />
      <path
        fill="#0468FF"
        d="M75.477 36.523c-6.031-6.031-15.845-6.031-21.876 0a15.464 15.464 0 00-3.767 15.7l-17.421 17.42c-.264.264-.412.621-.412.995v7.955c0 .778.629 1.407 1.406 1.407h7.956c.373 0 .73-.149.994-.412l1.988-1.99c.304-.304.452-.73.403-1.157l-.247-2.137 2.96-.278a1.404 1.404 0 001.268-1.268l.279-2.96 2.137.248c.396.053.796-.08 1.097-.346.3-.268.47-.65.47-1.05v-2.62h2.572c.373 0 .73-.148.994-.411l3.606-3.559c5.507 1.785 11.473.462 15.593-3.66 6.032-6.032 6.032-15.845 0-21.877z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M68 47a4 4 0 100-8 4 4 0 000 8zm-15.833 7.919l-16.97 16.97 1.413 1.414 16.971-16.97-1.414-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
};
